import { OrganizationsResource } from '~/resources';

const RolePermissionMixin = {
  methods: {
    saveSetting(role, permissionKey, status, retroactive = false) {
      return new Promise((resolve, reject) => {
        const params = { role, permission_key: permissionKey, status, retroactive };
        const request = OrganizationsResource.updateRoleSetting({ id: this.organizationId }, params, {
          abortReload: true,
        });

        request
          .then((response) => {
            if (response.success) {
              resolve(response);
            } else {
              reject(new Error(response.error));
            }
          })
          .catch(() => {
            reject(new Error('An error occurred. Please try again'));
          });
      });
    },
  },
};

export default RolePermissionMixin;
